import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { groupOptionScope3 } from "./groupOptionData";
import { Text } from "src/components/ui/Text";

const CheckBoxListsScope3 = (props) => {
  const { control, disabled } = props;

  return (
    <div>
      <div className="flex items-end gap-2 pb-1">
        <Text variant="bold-14">Scope 3</Text>
      </div>

      {/* main scope 3 */}
      <div className="flex flex-col gap-3">
        {groupOptionScope3?.map((item) => {
          const scopeName = item?.scope?.name;
          const scopeType = item?.scope?.type;
          const label = item?.name;
          const lists = item?.lists;
          const subScope = item?.subScope;
          const nameField = `scopes.scope3.${scopeType}`;

          return (
            <div key={item?.id}>
              <div className="flex items-end gap-2">
                <Text variant="bold-12">{scopeName}</Text>
                <Text variant="normal-12">{`${label}`}</Text>
              </div>

              {/* lists of sub scope 3 ->> 3.1 , 3.2 .... */}
              {lists && (
                <div>
                  <FieldSet
                    disabled={disabled}
                    name={nameField}
                    type="checkbox"
                    control={control}
                    label={""}
                    subLabel={""}
                    groupOptions={lists}
                  />
                </div>
              )}

              {/* sub scope 3 ->> 3.1 , 3.2 .... */}
              {subScope && (
                <div className="flex flex-col gap-2 pt-2 px-2">
                  {subScope?.map((subItem) => {
                    const subScopeName = subItem?.scope?.name;
                    const subScopeType = subItem?.scope?.type;
                    const subLabel = subItem?.name;
                    const groupOptions = subItem?.lists;
                    const nameField = `scopes.scope3.${subScopeType}`;

                    return (
                      <div key={subItem?.id}>
                        <div className="flex items-end gap-2">
                          <Text variant="bold-12">{subScopeName}</Text>
                          <Text variant="normal-12">{`${subLabel}`}</Text>
                        </div>

                        {/* lists of sub scope 3 ->> 3.1.1 , 3.1.2 .... */}
                        {groupOptions && (
                          <div>
                            <FieldSet
                              disabled={disabled}
                              name={nameField}
                              type="checkbox"
                              control={control}
                              label={""}
                              subLabel={""}
                              groupOptions={groupOptions}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckBoxListsScope3;
